import React from 'react';
import GenericPrivacyPolicyPage from '../../../components/GenericPrivacyPolicyPage';

const APP_NAME = 'Date Calculator';
const LAST_UPDATED_DATE = 'May 2025';

const PRIVACY_POLICY_CONTENT = `
This Privacy Policy describes how your information is handled when you use the Date Calculator application ("App").

1. Information We Collect
We do not collect any Personally Identifiable Information (PII) through the Date Calculator app. All calculations are performed locally on your device.

2. Data Usage
The app does not store or transmit any personal data or the results of your calculations. Any dates or information you enter are used solely for the calculation requested during your current session and are discarded when you close the app or perform a new calculation.

3. Third-Party Services
The Date Calculator app does not integrate with any third-party services (like analytics or advertising networks) that would collect user data.

4. Data Security
As all calculations are performed locally on your device and no data is stored or transmitted, the security of your information relies on the inherent security of your device and its operating system.

5. Data Retention
We do not retain any data entered into the App. Data exists only ephemerally during the calculation process within your active session.

6. Children's Privacy
This App is not directed to children under the age of 13. We do not knowingly collect any information from children under 13, as no data is collected by the App.

7. Changes to This Policy
We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our website. You are advised to review this Privacy Policy periodically for any changes.

8. Contact Us
If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support.datecalculator@codemates.app" style="color:#007bff;text-decoration:none;">support.datecalculator@codemates.app</a>.
`;

function DateCalculatorPrivacyPolicyPage() {
  return (
    <GenericPrivacyPolicyPage
      appName={APP_NAME}
      lastUpdatedDate={LAST_UPDATED_DATE}
      policyContent={PRIVACY_POLICY_CONTENT}
    />
  );
}

export default DateCalculatorPrivacyPolicyPage; 